import { Box as BoxUI, MaterialUICore, tokens } from '@iclinic/design-system';

const { styled } = MaterialUICore;

export const Container = styled(BoxUI)({
  display: 'flex',
  margin: tokens.spacing.sm,
  columnGap: tokens.spacing.sm,
});
